import React, { useState } from "react";
import ReactTable from "react-table";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { groups_get } from "../../../apis";
import auth from "../../../Auth";

import Typography from "@material-ui/core/Typography";

import GPAP_BUTTON, {
  GPAP_BUTTON_LIGHT,
} from "../../../../gpap-lib/Button_Collection";

const { config } = window;

export default function ShareDataDialog(props) {

  const {type, selected} = props;
  
  //columns for react-table
  const headers = [
    { label: `${type} ID`, key: "experiment" },
    { label: "Action", key: "action" },
    { label: "Current Visibility", key: "currentVisibility" },
    { label: "Current Groups", key: "currentGroups" },
  ];

  let actionSelected = "share with groups";
  if (props.action !== "shareWithGroups") {
    actionSelected = "unshare with groups";
  }

  let columns = [];
  for (let header of headers) {
    columns.push({ Header: header.label, accessor: header.key });
  }

  const [open, setOpen] = useState(false);
  let [data, setData] = useState({});
  let [groups, setGroups] = useState([]);
  let [valueSelected, setSelection] = useState("ALL");

  const getDataTable = () => {
    //Build data to render on react-table
    const data = [];
    
    for (const dataset of Object.entries(selected)) {
      const currentGroups = dataset[1].shared_with;
      const currentVisibility = dataset[1].visibility;

      

      // Fixme isUserOwner is not written consistently
      // sometimes it isUserOwner and sometimes IsUserOwner

      if (dataset[1].isUserOwner) {
        data.push({
          experiment: dataset[1].dataset_id,
          action: actionSelected,
          currentVisibility,
          currentGroups,
        });
      }
    }
    
    return data;
  };

  //query groups directly from keycloak
  //not yet working on integration
  // Cross-Origin Request Blocked:
  // The Same Origin Policy disallows reading the remote resource at
  // https://sso.cnag.crg.dev/auth/admin/realms/3TR/groups.
  // (Reason: CORS header ‘Access-Control-Allow-Origin’ missing).

  const getAllGroups = async () => {
    const conf = config.config_keycloak;
    const url = `${conf["auth-server-url"]}admin/realms/${conf.realm}/groups`;

    const res = await groups_get(auth.getToken(), url);
    let groupData = await res.json();
    let groups = groupData.map((group) => group.name);

    // get the user's groups and remove the leading slash
    const toRemove = auth.decoded().group.map((e) => e.slice(1));

    // remove the groups of the user and the admin group
    toRemove.push("admin");
    groups = groups.filter((el) => {
      return !toRemove.includes(el);
    });

    groups.unshift("ALL");
    setGroups(groups);
  };

  const handleClickOpen = () => {
    getAllGroups();
    setOpen(true);
    setData(getDataTable);
  };

  const handleApply = async () => {
    setOpen(false);
    props.handleUpdate(valueSelected);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectChange = (event) => {
    setSelection(event.target.value);
  };

  const groupOptions = (data) => {
    groups = data.groups;
    let items = [];

    for (let i = 0; i < groups.length; i++) {
      let group = groups[i];
      items.push(
        <option key={i} value={group}>
          {group}
        </option>
      );
    }
    return items;
  };

  return (
    <>
      <GPAP_BUTTON color="primary" onClick={handleClickOpen} data-cy={"btn-select-groups"}>
        select groups
      </GPAP_BUTTON>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Change visibility"}</DialogTitle>
        <DialogContent>
          <Typography variant={"subtitle1"}>
            Selection of your <b>own</b> {props.type} to apply the action:
            {actionSelected}
          </Typography>
          <Typography>
            Changes will be applied to all files associated to the selected{" "}
            {props.type}
          </Typography>
          <div className="p-2">
            <select
              className="mx-2 my-2"
              value={valueSelected}
              onChange={handleSelectChange}
            >
              {groupOptions({ groups })}
            </select>
          </div>
          <ReactTable
            data={data}
            filterable
            columns={columns}
            defaultPageSize={data.length}
            pageSizeOptions={[100, 200, 300]}
            className="-striped -highlight"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Not now
          </Button>
          <Button onClick={handleApply} color="primary" data-cy={"btn-update-table"}>
            Update Table
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
